module.exports = __webpack_public_path__ + "img/UlnarGutter2.2706329c.png";